<div class="wellness-survey">
    <div class="wellness-survey-header" *ngIf="headerText && headerText != ''">
        <h1>{{headerText}}</h1>
    </div>
    <div class="wellness-survey-table">
        <div class="wellness-survey-row" *ngFor="let wellnessSurvey of wellnessSurveys">
            <div class="wellness-survey-row-question" *ngIf="wellnessSurvey.type !== 'X'" [innerHTML]="wellnessSurvey.question">
            </div>
            <div class="wellness-survey-row-instruction" *ngIf="wellnessSurvey.type === 'X'" [innerHTML]="wellnessSurvey.question">
            </div>            
            <div class="wellness-survey-row-answer">
                <div *ngIf="wellnessSurvey.type === 'R'">
                    <div *ngIf="wellnessSurvey.align === 'H'">
                        <span *ngFor="let item of wellnessSurvey.options">
                            <p-radioButton 
                                name="answer{{wellnessSurvey.id}}radio" 
                                id="answer{{wellnessSurvey.id}}radio"
                                value="{{item}}" 
                                label="{{item}}"
                                (onClick)="onChangeType(type,$event)"
                                [(ngModel)]="wellnessSurvey.answer">
                            </p-radioButton>
                        </span>
                    </div>
                    <div *ngIf="wellnessSurvey.align === 'V'">
                        <div *ngFor="let item of wellnessSurvey.options">
                            <p-radioButton 
                                name="answer{{wellnessSurvey.id}}radio" 
                                id="answer{{wellnessSurvey.id}}radio"
                                value="{{item}}" 
                                label="{{item}}"
                                (onClick)="onChangeType(type,$event)"
                                [(ngModel)]="wellnessSurvey.answer">
                            </p-radioButton>
                        </div>        
                    </div>            
                </div>
                <div *ngIf="wellnessSurvey.type === 'C'">
                    <div *ngIf="wellnessSurvey.align === 'H'">
                        <span *ngFor="let item of wellnessSurvey.options">
                            <p-checkbox 
                                name="answer{{wellnessSurvey.id}}check"
                                id="answer{{wellnessSurvey.id}}check"                   
                                value="{{item}}"
                                label="{{item}}"
                                [(ngModel)]="wellnessSurvey.checkedAnswer"
                                (onChange)="checkvalue($event, wellnessSurvey)">
                            </p-checkbox>
                        </span>
                    </div>
                    <div *ngIf="wellnessSurvey.align === 'V'">
                        <div *ngFor="let item of wellnessSurvey.options">
                            <p-checkbox 
                                name="answer{{wellnessSurvey.id}}check"
                                id="answer{{wellnessSurvey.id}}check"                   
                                value="{{item}}"
                                label="{{item}}"
                                [(ngModel)]="wellnessSurvey.checkedAnswer"
                                (onChange)="checkvalue($event, wellnessSurvey)">
                            </p-checkbox>
                        </div>
                    </div>                
                </div>
                <div *ngIf="wellnessSurvey.type === 'D'">
                    <!-- <div style="padding-bottom: 5px;">
                        #Of Days
                    </div> -->
                    <div>
                        <p-inputNumber 
                            [(ngModel)]="wellnessSurvey.answer" 
                            [showButtons]="true" 
                            buttonLayout="horizontal" 
                            inputId="horizontal" 
                            spinnerMode="horizontal" 
                            [step]="1"
                            [min]="0" [max]="365"                            
                            decrementButtonClass="p-button-danger"
                            incrementButtonClass="p-button-success"
                            incrementButtonIcon="pi pi-plus" 
                            decrementButtonIcon="pi pi-minus" 
                            mode="decimal" 
                            currency="EUR" 
                            (ngModelChange)="onChangeDigit()"/>
                    </div>
                </div>
                <div *ngIf="wellnessSurvey.type === 'P'">
                    <!-- <div style="padding-bottom: 5px;">
                        #Of Days
                    </div> -->
                    <div>
                        <p-inputNumber 
                            [(ngModel)]="wellnessSurvey.answer" 
                            [showButtons]="true" 
                            buttonLayout="horizontal" 
                            inputId="horizontal" 
                            spinnerMode="horizontal" 
                            [step]="1"
                            [min]="0" [max]="100"
                            decrementButtonClass="p-button-danger"
                            incrementButtonClass="p-button-success"
                            incrementButtonIcon="pi pi-plus" 
                            decrementButtonIcon="pi pi-minus" 
                            mode="decimal" 
                            currency="EUR" 
                            (ngModelChange)="onChangeDigit()"/>
                    </div>
                </div>                
            </div>    
            <div class="wellness-survey-row-explainationlbl" *ngIf="wellnessSurvey.requireExplanation">
                Explain Details
            </div>                
            <div class="wellness-survey-row-explaination" *ngIf="wellnessSurvey.requireExplanation">
                <textarea rows="5" cols="100" [(ngModel)]="wellnessSurvey.explaination"></textarea>
            </div>                            
        </div>
    </div>
</div>